import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const eurojackpotConfig: LotteryConfigModel = {
    lottery: Lottery.eurojackpot,
    boardCount: 6,
    primaryBoardSize: 5,
    defaultStake: 0,
    defaultStakeKasa: 6000,
    primaryNumbers: 50,

    secondaryBoardSize: 2,
    secondaryNumbers: 12,

    addonBoardSize: 6,
    addonNumbers: 9,

    basePrice: 60,
    addonPrice: 40,

    primarySystemMinCount: 5,
    primarySystemDefaultCount: 6,
    primarySystemMaxCount: 10,
    secondarySystemMinCount: 2,
    secondarySystemDefaultCount: 2,
    secondarySystemMaxCount: 10,

    boardLabel: "Sloupec",
    hasDurationComponent: true,
    hasDrawOptions: true,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: true,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle:
        "Euromiliony se hrají pravidelně <strong>2x&nbsp;týdně</strong>, vždy v <strong>úterý</strong> a v <strong>sobotu</strong>.",
    durationTitleShort: "Eurojackpot se hraje pravidelně 2x týdně v úterý a pátek.",
    maxDuration: 24,
    multidrawDurationOptions: [
        { value: "tue", valueKasa: "TUESDAY", mainText: "Úterý", dayOfWeek: 2, hour: 19, drawName: "tue" },
        { value: "fri", valueKasa: "FRIDAY", mainText: "Pátek", dayOfWeek: 5, hour: 19, drawName: "fri" },
    ],
    hasCalculatedJackpot: false,
};
